import React, { useEffect, useMemo, useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';

import { FormProvider, CardAutocomplete } from 'components/Form';

import { Modal } from 'components/Modal';
import { useWatch } from 'react-hook-form';
import { getCompanies } from 'features/companies/api/getAllCompanies';
import { useGetRelatedFrameworkAgreements } from 'features/companies/api/getRelatedFrameworkAgreements';
import { useGetRelatedDPS } from 'features/companies/api/getRelatedDPS';

const CompanyItem = ({ Name, VAT, ...rest }) => (
  <Stack gap={1} alignItems={'flex-start !important'} {...rest}>
    <Typography variant="body1" fontWeight="bold">
      {Name} ({VAT})
    </Typography>
  </Stack>
);

export const MainInfo = ({
  companyID,
  handleCloseModal,
  methods,
  onSubmit,
  open,
  children,
}) => {
  const { control, setValue } = methods;

  // const selectedAgreementOrDps = useWatch({
  //   control,
  //   name: 'agreementOrDps',
  // });

  const selectedBuyerId = useWatch({
    control,
    name: 'buyer',
  });

  const selectedSupplierId = useWatch({
    control,
    name: 'supplierID',
  });

  const { data: agreementsResponse, isLoading: isLoadingAgreements } = useGetRelatedFrameworkAgreements(selectedBuyerId);
  const { data: dpsResponse, isLoading: isLoadingDps } = useGetRelatedDPS(selectedBuyerId);

  const isLoadingAgreementsOrDps = isLoadingAgreements || isLoadingDps;


  const agreementAndDpsOptions = useMemo(() => {
    const rawAgreements = agreementsResponse?.frameworkAgreements;
    const rawDps = dpsResponse?.dps;

    const mappedAgreements = (rawAgreements && Array.isArray(rawAgreements))
      ? rawAgreements.map(agreement => ({
          label: `${agreement?.fa_name} (Agreement)`,
          value: `agreement-${agreement?.fa_id}`,
        }))
      : [];
      
    const mappedDps = (rawDps && Array.isArray(rawDps))
      ? rawDps.map(dps => ({
          label: `${dps?.dps_name} (DPS)`,
          value: `dps-${dps?.dps_id}`,
        }))
      : [];

    return [...mappedAgreements, ...mappedDps];
  }, [agreementsResponse, dpsResponse]);


  // useEffect(() => {
  //   if (selectedAgreementOrDps) {
  //     const selectedAgreement = agreementAndDpsOptions.find(opt => opt.value === selectedAgreementOrDps);
  //     setValue('agreementName', selectedAgreement ? selectedAgreement.label : '');
  //   } else {
  //     setValue('agreementName', '');
  //   }
  // }, [selectedAgreementOrDps, agreementAndDpsOptions, setValue]);

  // useEffect(() => {
  //   const selectedValue = selectedAgreementOrDps;
  //   if (selectedValue) {
  //     const selectedOption = agreementAndDpsOptions.find(opt => opt.value === selectedValue);
  //     setValue('agreementName', selectedOption ? selectedOption.label : '');

  //     if (selectedValue.startsWith('dps-')) {
  //       const dpsId = parseInt(selectedValue.split('-')[1], 10);
  //       setValue('dps', dpsId);
  //       setValue('agreement', null);
  //     } else if (selectedValue.startsWith('agreement-')) {
  //       const agreementId = parseInt(selectedValue.split('-')[1], 10);
  //       setValue('agreement', agreementId);
  //       setValue('dps', null);
  //     }
  //   } else {
  //     setValue('dps', null);
  //     setValue('agreement', null);
  //     setValue('agreementName', '');
  //   }
  // }, [selectedAgreementOrDps, agreementAndDpsOptions, setValue]);

  return (
    <Modal title="Add Advertisement" handleClose={handleCloseModal} open={open}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack>
          <CardAutocomplete
            name="buyer"
            label="Select Buyer"
            queryFunction={(search) => getCompanies('buyer', 15, true, search)}
            optionLabelName="Name"
            ItemCard={CompanyItem}
            onChange={(newValue) => {
              setValue('buyer', newValue ? newValue.company_id : null);
              setValue('buyerName', newValue ? newValue.Name : null);
            }}
            skipCreatingShadow={true}
            fetchOnOpen={true}
            fullWidth
            loadingInitial
            changeSelectedValueOnChange={true}
          />
          {/* <Select
            name="agreementOrDps"
            label="Select Agreement"
            options={agreementAndDpsOptions}
            placeholder="Please select agreement"
            disabled={!selectedBuyerId || isLoadingAgreementsOrDps}
            required
            fullWidth
          /> */}
          {children}
          <Button
            size="large"
            type="submit"
            variant="contained"
            color="primary"
            sx={{ mt: 2, mb: 0.5 }}
          >
            Add Advertisement
          </Button>
        </Stack>
      </FormProvider>
    </Modal>
  );
};
